document.addEventListener("DOMContentLoaded", function (event) {
  $(".product-information__tab-child").eq(0).addClass("open");

  $(".product-information__title").click(function (e) {
    e.preventDefault();

    $(".product-information__title").removeClass("active");

    $(this).addClass("active");

    let parentIndex = $(this).attr("data-tab-parent");

    $(".product-information__tab-child").removeClass("open");

    $(
      '.product-information__tab-child[data-tab-child="' + parentIndex + '"]'
    ).addClass("open");
  });
});

